export const SITE_URL = "https://www.pm-powerconsulting.com";

export const API_BASE_URL =
  window.location.hostname === "localhost"
    ? "http://localhost:8000/podcasts/api"
    : "https://ask.pm-powerconsulting.com/podcasts/api";

export const APP_ROUTES = {
  home: "/",
  adminPodcasts: "/admin/podcasts",
  stories: "/stories",
  sps: "/sps",
  podcastList: "/podcast-list",
  podcast2: "/podcast-2",
} as const;

export const URLS = {
  site: SITE_URL,
  search: `${SITE_URL}/?s=`,
  searchFormId: "997867",
  offerings: `${SITE_URL}/#offerings`,
  experts: `${SITE_URL}/experts/`,
  successStories: `${SITE_URL}/success-stories/`,
  insights: `${SITE_URL}/insights/`,
  aboutUs: `${SITE_URL}/about-us/`,
  podcastList: `${SITE_URL}/podcast-2/`,
  softwarePeopleStories: `${SITE_URL}/software-people-stories/`,
  fullStackLeadershipcast: `${SITE_URL}/full-stack-leadershipcast/`,
  powerGuide: "https://powerguide.ai/",
  youtubeChannel: "https://www.youtube.com/@pm-power-consulting",
  youtubeSubscribe: "https://www.youtube.com/@pm-powerconsulting?sub_confirmation=1",
  linkedin: "https://www.linkedin.com/company/pm-power-consulting/",
} as const;

export const PLAYLIST_URLS = {
  favourites: "https://www.youtube.com/playlist?list=PL4XtBUzCNYXBaY1c29wvKS51nEP-4lak7",
  womensMonth: "https://www.youtube.com/playlist?list=PL4XtBUzCNYXClf5r5Fgk4Isl629izITzv",
  startupJourneys: "https://www.youtube.com/playlist?list=PL4XtBUzCNYXAoKkeFZx21FA1d-T2eqVN9",
  architectSpeak: "https://www.youtube.com/playlist?list=PL4XtBUzCNYXCw-nhunjlcDTYPjNspcxFJ",
  userExperience: "https://www.youtube.com/playlist?list=PL4XtBUzCNYXA5pSS4QKcsXTw0NHvCSe1i",
} as const;

export const PLATFORM_URLS = {
  applePodcasts:
    "https://itunes.apple.com/us/podcast/software-lifecycle-stories/id1441861184?mt=2&uo=4&ls=1",
  spotify: "https://open.spotify.com/show/69cBIKyP522EtLlfncssE8",
  tuneIn: "http://tunein.com/podcasts/Technology-Podcasts/Software-Lifecycle-Stories-p1162831/",
  youtubeMusic:
    "https://www.youtube.com/watch?v=sw6mo70nslw&list=PL4XtBUzCNYXBEzFjXN8j0c7BibEx9QSBN",
  iHeartRadio: "http://www.iheart.com/podcast/256-software-lifecycle-stories-31123433/",
  listenNotes: "https://www.listennotes.com/c/eef3a490882248e0972fc57173fd937d/",
  podchaser: "https://www.podchaser.com/podcasts/software-people-stories-754600",
} as const;

export const youtubeEmbedUrl = (videoId: string) =>
  `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
